import React from 'react';
import styled from 'styled-components';
import CompanyUsers from './components/companyUsers';
import HomeDashboard from './components/homeDashboard';
import ManageCriteria from './components/ManageCriteria';
// import Invites from './components/Invites';

const DashboardWrapper = styled.div`
  padding: 110px 60px;
  transition: margin 0.2s;
  margin-left: ${props => (props.open ? '376px' : '60px')};
  @media (min-width: 0px) and (orientation: landscape) {
    margin-top: 48px;
  }
  @media (min-width: 600px) {
    margin-top: 64px;
  }
`;

class Dashboard extends React.Component {
  state = {};

  handleListItemClick = (event, index) => {};

  render() {
    const { selectedIndex } = this.props;
    return (
      <DashboardWrapper open={this.props.open}>
        {selectedIndex === 0 ? <HomeDashboard /> : null}
        {selectedIndex === 1 ? <CompanyUsers arupUsers={true} /> : null}
        {selectedIndex === 2 ? <CompanyUsers arupUsers={false} /> : null}
        {/* {selectedIndex === 3 ? <Invites /> : null} */}
        {selectedIndex === 4 ? <ManageCriteria /> : null}
      </DashboardWrapper>
    );
  }
}

export default Dashboard;
